import { FavoriteButtonWrapperContainer } from '@cian/favorites-assign-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { DefaultFavoriteButton, DefaultFavoriteButtonNew } from '../../components/FavoriteButton/DefaultFavoriteButton';
import { FavoritesButtonContext } from '../../context';
import { offerSelector, selectFullscreenGalleryOpened, selectIsAuthenticated } from '../../selectors';

export interface IFavoriteButtonGalleryAdaptationContainerProps {
  checked: boolean;
  onButtonClick(): void;
  newButton?: boolean;
}

export const FavoriteButtonGalleryAdaptationContainer = ({
  checked,
  newButton,
  onButtonClick,
}: IFavoriteButtonGalleryAdaptationContainerProps) => {
  const { placement } = React.useContext(FavoritesButtonContext);
  const isFullscreenGalleryOpened = useSelector(selectFullscreenGalleryOpened);
  const offer = useSelector(offerSelector);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const Control = newButton ? DefaultFavoriteButtonNew : DefaultFavoriteButton;

  if (placement === 'gallery' || isFullscreenGalleryOpened || !isAuthenticated) {
    return <Control checked={checked} onButtonClick={onButtonClick} />;
  }

  return (
    <FavoriteButtonWrapperContainer offerId={offer.id} placement="bottom">
      <Control checked={checked} onButtonClick={onButtonClick} />
    </FavoriteButtonWrapperContainer>
  );
};
